// extracted by mini-css-extract-plugin
module.exports =  {"container":"_2P2I_Fuci_z1kHM-nf2OCH","card":"_3Arm7vAxHKC9u9zU6FIybE"};